import { RouteEnum } from "../Enums/RouteEnums";

const RouteHelper = {

    getRouteDescription: function (routeEnum: any, isSingle=false) {
        switch (routeEnum) {
            //AUTH
            case RouteEnum.LOGIN: return 'Login';
            case RouteEnum.SIGN_UP: return 'Sign Up';
            case RouteEnum.LOGOUT: return 'Logout';
            case RouteEnum.FORGOT_PASSWORD: return 'Forgot Password';
            case RouteEnum.RESET_PASSWORD: return 'Reset Password';
            case RouteEnum.OTP: return 'OTP Verification';
            case RouteEnum.RECOVER_ACCOUNT: return 'Recover Account';
            
            //DASHBOARD
            case RouteEnum.DASHBOARD: return 'Dashboard';

            //ADMIN
            case RouteEnum.ADMIN_USER_CONTROL: return isSingle ? 'Admin User Control' : 'Admin User Controls';
            case RouteEnum.ADMIN_USER_DETAILS: return 'Admin User Details';

            //COMPANY
            case RouteEnum.COMPANIES: return isSingle ? 'Company' : 'Companies';
            case RouteEnum.COMPANY_USERS: return isSingle ? 'Company User' : 'Company Users';
            case RouteEnum.COMPANY_DETAILS: return 'Company Details';
        
            //BILLING
            case RouteEnum.BILLINGS: return isSingle ? 'Billing' : 'Billings';
            case RouteEnum.BILLING_DETAILS: return 'Billing Details';

            //LICENSE
            case RouteEnum.LICENSES: return isSingle ? 'License' : 'Licenses';
            case RouteEnum.LICENSE_DETAILS: return 'License Details';

            //LICENSE
            case RouteEnum.INSTANCE_MANAGEMENT: return isSingle ? 'Instance Management' : 'Instance Mgmt';
            case RouteEnum.INSTANCE_MANAGEMENT_DETAILS: return 'Instance Management Details';

            case RouteEnum.BUY_LICENSE: return 'Buy License';
            case RouteEnum.BUY_LICENSE_PACKAGE: return 'Buy License (Package)';
            case RouteEnum.GENERATE_LICENSE: return 'Generate License';

            //MAINTENANCE
            case RouteEnum.MAINTENANCE: return 'Maintenance';
            case RouteEnum.ACCESSIBILITIES: return isSingle ? 'Accessibility' : 'Accessibilities';
            case RouteEnum.ACCESSIBILITY_DETAILS: return 'Accessibility Details';
            case RouteEnum.MODULE_SETTING: return 'Module Settings';
            case RouteEnum.PRICE_SETTING: return 'Price Settings';
            case RouteEnum.VENDORS: return 'Vendors';
            case RouteEnum.REGISTRATION_CODES: return 'Registration Codes';

            //MAINTENANCE
            case RouteEnum.MY_PROFILE: return 'My Profile';
            default: return 'Home';
        }
    }
}

export default RouteHelper;